module.exports = __webpack_public_path__ + "static/media/innoviti_genie_plus.3b09885d.png";